import { Controller } from "@hotwired/stimulus"

// Centres the element named by the URL fragment instead of pinning it to the
// top of the viewport.
//
// A plain anchor aligns the target with the top of the page, where the fixed
// header covers it — arriving from the active workout bar, the current
// exercise showed up cut in half. Centring keeps it fully visible with its
// surrounding sets in view.
export default class extends Controller {
  connect() {
    this.centre()
  }

  centre() {
    const { hash } = window.location
    if (!hash || hash.length < 2) return

    const target = document.getElementById(hash.slice(1))
    if (!target) return

    // Runs after the browser has done its own anchor jump, so this wins.
    requestAnimationFrame(() => {
      // Centring an element taller than the viewport would push its top out
      // of view — the very problem this fixes. Align to the top instead.
      const tallerThanViewport = target.offsetHeight > window.innerHeight
      const block = tallerThanViewport ? "start" : "center"

      target.scrollIntoView({ block, behavior: "instant" })
    })
  }
}
